import { render, staticRenderFns } from "./infoModify.vue?vue&type=template&id=7ed33364&scoped=true"
import script from "./infoModify.vue?vue&type=script&lang=js"
export * from "./infoModify.vue?vue&type=script&lang=js"
import style0 from "./infoModify.vue?vue&type=style&index=0&id=7ed33364&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed33364",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed33364')) {
      api.createRecord('7ed33364', component.options)
    } else {
      api.reload('7ed33364', component.options)
    }
    module.hot.accept("./infoModify.vue?vue&type=template&id=7ed33364&scoped=true", function () {
      api.rerender('7ed33364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/concatTeacher/infoModify.vue"
export default component.exports